import { IconButton, Stack } from '@mui/joy';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export function InlineEditButtons({ onSave, onCancel, disabled = false }) {
  return (
    <Stack direction="row" gap={0.5}>
      <IconButton size="sm" color="neutral" onClick={onSave} disabled={disabled}>
        <CheckIcon />
      </IconButton>
      <IconButton size="sm" color="neutral" onClick={onCancel} disabled={disabled}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
}

